import { useUser } from "../../../../../utils/hooks/commonly-stored/users";
import InfoItem from "../../PartDetails/InfoItem";

const ConsignmentUserInfo = ({ userId }: { userId: string }) => {
  const { user } = useUser(userId);

  if (user === null) {
    return null;
  }

  return (
    <InfoItem
      label={"Consigned"}
      value={`Container is a consignment part reserved for use by ${user.email} only and it is not included in in stock quantity`}
    />
  );
};

export default ConsignmentUserInfo;
